module.exports = __webpack_public_path__ + "static/media/Portrait-10244.a5593287.jpg";